export const PURGE = 'PURGE'

export const NETWORK_CONNECTION_CHANGE = 'NETWORK_CONNECTION_CHANGE'

export const SCENE = 'SCENE'
